/*    通信核心
 *    本模块的设计核心思想何作用：对后端程序的接口调用操作；主要负责如：错误捕获，调用队列控制，
 * 身份信息绑定，通信配置，异常处理。
 *    Django 2018/4/13
 */

import axios from 'axios'
import passport from '../javascripts/passport'
import { autoLogin } from '@vestleader/wechat-login'
// import fs from 'fs'
import { MessageBox, Message } from 'element-ui'
console.log(process.env.NODE_ENV)
const DEV_RGE = /(127.0.0.1|localhost)/g

const baseURL = DEV_RGE.test(window.location.host)
  ? 'http://localhost:1000/'
  : '//'
axios.defaults.baseURL = baseURL
axios.defaults.timeout = 1000 * 300
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + passport.getInfo()
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use((res) => {
  return res
}, (error) => {
  return Promise.reject(error)
})

/*
 *  保持线程同步，是一个关键问题
 *  processInLogin  登录开关，如果发现401，则开启登录，设置这个变量为true，
 *                  所有因403返回的问题，全部阻断
 *  waitForLogin    所有阻断的请求，当完成登录之后再次重新启动
 *                  {f:回调函数,a:参数,t:异步结果回调}
 */
function getFieldInUri (uri, field) {
  const firstAt = uri.indexOf(field)
  if (firstAt < 0) {
    return ''
  }
  let end = uri.indexOf('&', firstAt + 1)
  end = end < 0 ? uri.indexOf('#', firstAt + 1) : end
  if (end < 0) end = uri.length
  return uri.substring(firstAt + field.length, end)
}

let processInLogin = false
const waitForLogin = []

// 成功登录之后的处理
function whenLoginIn () {
  console.log('登录成功后，执行被阻塞的线程')
  processInLogin = false
  for (var x in waitForLogin) {
    console.info(`执行阻塞线程${x}`)
    waitForLogin[x].f.apply(this, waitForLogin[x].a).then(waitForLogin[x].t)
  }
}
window.whenLoginIn = whenLoginIn

// 打开登录模态框，做登录操作
async function showLoginModal () {
  try {
    if (processInLogin) return // 如果已经在处理登录了，只需要显示一个层（独占）
    const href = window.location.href.replace('/login', '')
    const loginCode = getFieldInUri(href, 'loginCode=')
    if (loginCode) {
      CommonAjax({ loginCode }, '/login', 'get').then((res) => {
        if (res.errCode === 0 && res.data) {
          passport.setInfo(res.data)
          window.location.href = sessionStorage.getItem('url') || href
          // window.location.reload()
          whenLoginIn()
        } else {
          Message.error({ duration: 0, message: res.msg })
        }
      })
      return
    }

    sessionStorage.setItem('url', href)
    processInLogin = true
    MessageBox.alert(
      `<div style="display:flex;">
        <div id="wx_reg" style="text-align: center;"></div>
        <div style="text-align: center;margin-left:10px;">
          <p style="color:#0082EF;font-size:20px">登录头豹后台</p>
          <div style="width:100%;margin-top:30px;text-align:center">
            <p>点击确定前往登录前往登录</p>
          </div>
        </div>
      </div>`,
      ' ',
      {
        dangerouslyUseHTMLString: true,
        showConfirmButton: true,
        showClose: true,
        customClass: 'login-model',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            CommonAjax(null, '/toLogin', 'get').then((res) => {
              window.location.href = res.data
              done()
            })
          } else {
            done()
          }
        }
      }
    )
  } catch (err) { }
}
// showLoginModal()
function DownloadFile (url, filename) {
  return new Promise((resolve, reject) => {
    axios({ method: 'GET', url: url, responseType: 'arraybuffer' }).then(res => {
      resolve(new Blob([res.data]))
    })
  })
}

// 通用异步调用
function CommonAjax (data, url, method = 'get') {
  let params = {}
  if (method.toLocaleLowerCase() === 'get') {
    params = { method: method, url: url, params: data }
  } else {
    params = { method: method, url: url, data: data }
  }
  return new Promise((resolve, reject) => {
    axios(params).then(res => {
      resolve(res.data)
    }).catch(err => {
      if (typeof err.response !== 'undefined' && typeof err.response.status !== 'undefined') {
        const code = err.response.status
        switch (code) {
          case 401: // unauthoried
            console.warn('请求拒绝，需要重新登录，本次请求加入重新请求队列')
            waitForLogin.push({
              f: CommonAjax,
              a: arguments,
              t: function (r) { resolve(r) }
            })
            autoLogin({
              PC_QYWX: (code) => {
                ajax({ code: code }, '/autologinByWx', 'get').then(res => {
                  if (res && res.data) {
                    passport.setInfo(res.data)
                    location.href = window.location.origin
                  }
                })
              },
              MOBILE_QXWX: (code) => {
                ajax({ code: code }, '/autologinByWx', 'get').then(res => {
                  if (res && res.data) {
                    passport.setInfo(res.data)
                    location.href = window.location.origin
                  }
                })
              },
              OTHER: () => {
                showLoginModal()
              }
            })
            break
          case 403:
            Message({ message: '无权限', type: 'error', duration: 3000 })
            console.warn('无权限')
            break
          case 404:
            console.error('===========访问的资源不存在，请检查===========')
            break
          case 406:
            break
          case 500:
            console.error('===========服务器罢工============')
            console.error(`data:${JSON.stringify(data)}, url:${url}, method:${method}`)
            break
          default:
            console.error(`${code} 未做错误代码的捕获的后端端异常`)
            break
        }
        return
      }
      reject(err)
    })
  })
}

function ajax (data, url, method) {
  return new Promise((resolve, reject) => {
    CommonAjax(data, url, method).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 退出登录
function Logout () {
  if (!passport.getInfo()) return true
  return new Promise((resolve, reject) => {
    CommonAjax(null, '/logout', 'get').then((res) => {
      if (res.errCode === 0) {
        resolve(true)
        localStorage.clear()
        sessionStorage.clear()
      } else {
        resolve(false)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export default {
  ajax,
  showLoginModal,
  processInLogin,
  downloadFile: DownloadFile,
  Logout
}
